import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { Card } from "nectar-ui";
import { NectarTheme } from "../../../typings/theme";

export const CardWrapper = styled(Card)`
  ${({ theme }: NectarTheme) => css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.lg};
    padding: ${theme.spacings.lg};
    position: relative;

    .apexcharts-tooltip {
      white-space: pre-wrap !important;
      max-width: 200px;
    }

    .apexcharts-tooltip-title {
      margin-bottom: ${theme.spacings.xs};
      font-weight: 700;
      padding-left: ${theme.spacings.sm};
      font-size: 14px;
    }

    .apexcharts-tooltip-text-y-label {
      color: ${theme.colors.gray500};
      font-weight: 500;
      font-size: 14px;
    }

    .apexcharts-tooltip-text-y-value {
      font-weight: 700;
      font-size: 14px;
    }

    .apexcharts-tooltip-series-group {
      margin-top: ${theme.spacings.xxs} !important;
      margin-bottom: ${theme.spacings.xs} !important;
    }

    .apexcharts-legend {
      flex-direction: column;
      gap: ${theme.spacings.xs} 0px;
    }

    ${theme.breakpoints.sm} {
      .apexcharts-legend {
        flex-direction: row;
        gap: 0px ${theme.spacings.xs};
      }
    }
  `}
`;

export const TitleWrapper = styled.div`
  ${({ theme }: NectarTheme) => `
    display: flex;
    flex-direction: row;
    gap: ${theme.spacings.xs};
  `}
`;

export const ActionWrapper = styled.div`
  ${({ theme }: NectarTheme) => `
    display: flex;
    flex-direction: row;
    gap: ${theme.spacings.md};
    color: ${theme.colors.gray500};

    & i {
      cursor: pointer;
    }
  `}
`;
